export function regexStringEscape(regex) {
    let char = "";
    let escapedRegex = "";
    const N = regex.length;
    for (let i = 0; i < N; i++) {
        char = regex[i];
        switch (char) {
            case "\\":
                escapedRegex += "\\\\";
                break;
            case "^":
                escapedRegex += "\\^";
                break;
            case "$":
                escapedRegex += "\\$";
                break;
            case "*":
                escapedRegex += "\\*";
                break;
            case "+":
                escapedRegex += "\\+";
                break;
            case "-":
                escapedRegex += "\\-";
                break;
            case "?":
                escapedRegex += "\\?";
                break;
            case ".":
                escapedRegex += "\\.";
                break;
            case "(":
                escapedRegex += "\\(";
                break;
            case ")":
                escapedRegex += "\\)";
                break;
            case "[":
                escapedRegex += "\\[";
                break;
            case "]":
                escapedRegex += "\\]";
                break;
            case "|":
                escapedRegex += "\\|";
                break;
            default:
                escapedRegex += char;
                break;
        }
    }
    return escapedRegex;
}
//# sourceMappingURL=regexStringEscape.js.map